import React from "react";
import MonthAndBranchesModal from "../../../components/templates/MonthAndBranchesModal";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { SelectItem as SelectItemComponent } from "../../../components/forms/FormItems";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import { useIntl } from "react-intl";
import moment from "moment";

const PrintDiariesModal = ({
  branchId,
  printDiariesVisible,
  hidePrintDiaries,
  branchName,
  onPrintDiaries,
  printLoading,
  printDiariesValues,
  setPrintDiariesValues,
}) => {
  const intl = useIntl();
  const staffFilter = { filter: { $and: [{ staff_member: true }] } };
  const AdditionalItems = () => (
    <>
      {!printDiariesValues.is_empty && (
        <SelectItemComponent
          name="diaries_export_type"
          category="employee"
          diariesExportType={true}
          required={true}
        />
      )}

      {printDiariesValues.diaries_export_type === "staff_worker_in_charge" &&
        !printDiariesValues.is_empty &&
        (printDiariesValues.branches || branchId) && (
          <EmployeesSelect
            name="staff_worker_in_charge_id"
            category="employee"
            waitForFetch={!printDiariesValues.branches && !branchId}
            extraParams={{
              ...staffFilter,
              scopePrefix: `branches/${
                printDiariesValues.branches || branchId
              }/`,
            }}
          />
        )}
      <CheckBoxItem name={"is_empty"} category="employee" showLabel />
      <CheckBoxItem
        name={"exclude_presense_reporting_clients"}
        category="employee"
        showLabel
      />
    </>
  );
  return (
    <MonthAndBranchesModal
      onHide={hidePrintDiaries}
      visible={printDiariesVisible}
      title={
        !branchId
          ? intl.formatMessage({
              id: "app.employees.print_diaries",
            })
          : `${intl.formatMessage({
              id: "app.employees.print_diaries_for_branch",
            })}${branchName}`
      }
      btnText={intl.formatMessage({
        id: "app.actions.print",
      })}
      initialValues={{
        month: moment(),
        branches: branchId ? +branchId : null,
        exclude_presense_reporting_clients: true,
      }}
      onSubmit={onPrintDiaries}
      branchId={branchId}
      loading={printLoading}
      single={true}
      additionaItems={<AdditionalItems />}
      requiredItems={["diaries_export_type"]}
      onChange={(form, changedValues, allValues) => {
        setPrintDiariesValues(allValues);
        const updatedValues = { ...allValues };
        if (
          "branches" in changedValues ||
          "diaries_export_type" in changedValues ||
          "is_empty" in changedValues
        ) {
          updatedValues.staff_worker_in_charge_id = null;
        }
        if ("is_empty" in changedValues) {
          if (changedValues.is_empty) {
            updatedValues.diaries_export_type = "all";
          }
        }
        form.setFieldsValue(updatedValues);
      }}
    />
  );
};

export default PrintDiariesModal;
